import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_upload_custom_image_evidence",
  ref: "uploadCustomImageEvidenceModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered w-400px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Upload Image", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_9 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_10 = {
  class: "dropzone",
  ref: "dropRef"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"dz-message needsclick\"><i class=\"bi bi-file-earmark-arrow-up text-primary fs-3x\"></i><div class=\"ms-4\"><h3 class=\"fs-5 fw-bolder text-gray-900 mb-1\"> Drop files here or click to upload. </h3><span class=\"fs-7 fw-bold text-gray-400\">Upload the image</span></div></div>", 1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _hoisted_12, 512)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-sm btn-primary",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.formSubmit()), ["prevent"])),
              ref: "submitButton",
              "data-kt-menu-dismiss": "false"
            }, _hoisted_16, 512)
          ])
        ])
      ])
    ])
  ], 512))
}